export const formattedDateToDayJs = (date: string | undefined) => {
    const splitDate = date?.indexOf('-') ? date?.split('-') : date?.split('.');
    if (splitDate?.length === 3) {
        return [splitDate[2], splitDate[1], splitDate[0]].join('-');
    }
    return '';
};
